import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UnderlineOutlinedSvg from "@ant-design/icons-svg/es/asn/UnderlineOutlined";
import AntdIcon from "../components/AntdIcon";
var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnderlineOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UnderlineOutlined.displayName = 'UnderlineOutlined';
}
export default /*#__PURE__*/React.forwardRef(UnderlineOutlined);